import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: 'root'
})
export class LogService {
	private readonly isDevelopment = !environment.production;

	debug(message: string, data?: any): void {
		if (!this.isDevelopment) return;
		const safeData = this.sanitize(data);
		const safeMessage = this.sanitize(message);
		// eslint-disable-next-line no-console
		console.debug('[DEBUG]', safeMessage, safeData);
	}

	private sanitize(data: any): any {
		if (!data) return data;

		if (typeof data === 'string') {
			return data;
		}

		if (typeof data === 'object') {
			return JSON.parse(JSON.stringify(data));
		}

		return data;
	}
}
